import { render } from "./pillConfirm.vue?vue&type=template&id=0958c440&scoped=true"
import script from "./pillConfirm.vue?vue&type=script&lang=js"
export * from "./pillConfirm.vue?vue&type=script&lang=js"

import "./pillConfirm.vue?vue&type=style&index=0&id=0958c440&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0958c440"]])

export default __exports__